// extracted by mini-css-extract-plugin
module.exports = {"root":"Slick_root__w9PXT"};